import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import TemplateEOC from '../Components/Template/template-eoc';
import TemplateEPL from '../Components/Template/template-epl';
import * as ProjectActionType from '../constants';
import {connect} from 'react-redux';

class ProjectAddEditTemplates extends Component {
  static propTypes = {
    projectId: PropTypes.string,
    dispatch: PropTypes.func,
    DefaultTemplateList: PropTypes.array,
    DefaultTemplateList2: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  getDefaultTemplate = () => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE_ASYNC,
      params: {
        projectId: this.props.projectId
      }
    });
  }

  getDefaultTemplate2 = () => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_ASYNC,
      params: {
        projectId: this.props.projectId
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <Tab.Container
          id='left-tabs-example'
          defaultActiveKey='first'
          className='s1-stack-tab'
        >
          <Row className='clearfix'>
            <Col sm={2} style={{ paddingRight: 0 }}>
              <Nav bsStyle='pills' stacked>
                <NavItem eventKey='first'>ESF</NavItem>
                <NavItem eventKey='second'>EPL</NavItem>
              </Nav>
            </Col>
            <Col sm={10}>
              <Tab.Content
                animation
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  border: '1px solid #e6e6e6',
                  backgroundColor: '#fff'
                }}>
                <Tab.Pane eventKey='first'>
                  <TemplateEOC
                    projectId={this.props.projectId}
                    DefaultTemplateList={this.props.DefaultTemplateList}
                    getDefaultTemplate={this.getDefaultTemplate}/>
                </Tab.Pane>
                <Tab.Pane eventKey='second'>
                  <TemplateEPL
                    projectId={this.props.projectId}
                    DefaultTemplateList={this.props.DefaultTemplateList2}
                    getDefaultTemplate={this.getDefaultTemplate2}/>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DefaultTemplateList: state.ProjectStore.DefaultTemplateList,
    DefaultTemplateList2: state.ProjectStore.DefaultTemplateList2
  };
};

export default connect(mapStateToProps)(ProjectAddEditTemplates);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-templates.js